import React, { Component, PropTypes } from "react";
import Task from "./Task";
import { Paper, Styles } from "material-ui";
import styles from "./Styles";
import Loader from "components/Material/Loader";
import { TaskActions } from "actions";
import { mixin, RefluxMixin } from 'Util';
import { SettingsActions } from 'actions';
import { SettingsStore } from 'stores';

const { Spacing } = Styles;

export default class TaskList extends mixin(
    RefluxMixin,
    Component
) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }


    SettingsActions.read();
  }

  listenToStores() {
    this.listenToStore(SettingsStore, 'settings');
  }

  componentDidUpdate() {
    const taskId = this.props.selected;
    if (!taskId) {
      return;
    }
    const selectedTask = document.getElementById(`task-${taskId}`);
    if (!selectedTask) {
      return;
    }
    selectedTask.scrollIntoView();
    TaskActions.clearTaskSelection();
  }

  hasUnCorrectedTasks = results => {
    let uncorrectedCount = 0;
    for (let i = 0; i < results && results.length; i++) {
      const element = results[i];
      if (
        element &&
        element.feedback &&
        !element.feedback.created &&
        typeof element.feedback.created_by !== "number"
      ) {
        uncorrectedCount++;
      }
    }
    return uncorrectedCount;
  };

  render() {
    const { tasks, canGrade, tasksLoading, hasFilter, taskMode } = this.props;
    const { settings } = this.state
    const { canvasColor } = this.context.muiTheme.rawTheme.palette;
    let taskStyle = Object.assign(
      {
        backgroundColor: canvasColor
      },
      styles.task
    );
    let taskItems, noResults;
    if (tasks.length > 0) {
      taskItems = tasks
        .sort((a, b) => {
          let A = this.hasUnCorrectedTasks(a.taskResults);
          let B = this.hasUnCorrectedTasks(b.taskResults);
          if (A < B) {
            return -1;
          }
          if (A > B) {
            return 1;
          }
          return 0;
        })
        .reverse()
        .map(task => {
          if (!task.caption.hasOwnProperty('main')) {
            task.caption.main = 'Task has no caption';
          }
          const { id, ...other } = task;

          return (
            <Paper key={id} style={taskStyle}>
              <Task
                taskMode={taskMode}
                id={id}
                {...other}
                settings={settings}
                canAnswer={false}
                canGrade={true}
              />
            </Paper>
          );
        });
    } else if (!hasFilter) {
      noResults = (
        <div style={styles.makeSelection}>
          {this.context.getIntlMessage("selectFilter")}
        </div>
      );
    } else if (tasksLoading) {
      noResults = <Loader />;
    } else {
      noResults = (
        <div style={styles.noResults}>
          {this.context.getIntlMessage("noResults")}
        </div>
      );
    }
    if (taskItems && !taskItems[0]) {
      return <div style={styles.makeSelection}>{this.context.getIntlMessage('tasks.noTasks')}</div>;
    }

    return (
      <div>
        {taskItems}
        {noResults}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TaskList.js